import React, { useState, useEffect } from 'react';
import { apiFetch } from '../../hooks/useApi';
import {
  AlertIcon, PackageIcon, CheckIcon, XIcon,
  RefreshIcon, ClockIcon, UserIcon,
} from '../../components/Icons';

const ESTADOS_LABEL = {
  aberta:      { label: 'Aberta',      cls: 'badge-danger'  },
  em_analise:  { label: 'Em análise',  cls: 'badge-warning' },
  resolvida:   { label: 'Resolvida',   cls: 'badge-success' },
  encerrada:   { label: 'Encerrada',   cls: 'badge-neutral' },
};

export default function DisputasAdmin() {
  const [disputas,    setDisputas]    = useState([]);
  const [load,        setLoad]        = useState(true);
  const [erro,        setErro]        = useState('');
  const [sucesso,     setSucesso]     = useState('');
  const [provasId,    setProvasId]    = useState(null);
  const [modal,       setModal]       = useState(null); // { disputa, tipo: 'devolver'|'reter' }
  const [resolucao,   setResolucao]   = useState('');
  const [valorRetido, setValorRetido] = useState('');
  const [salvando,    setSalvando]    = useState(false);
  const [filtro,      setFiltro]      = useState('abertas');

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setLoad(true);
    try {
      const data = await apiFetch('/admin/disputas');
      setDisputas(data.disputas || []);
    } catch (e) { setErro(e.message); }
    finally { setLoad(false); }
  };

  const resolver = async (id, estado, resolucaoTexto, valorRet) => {
    setSalvando(true);
    try {
      await apiFetch(`/admin/disputas/${id}`, 'PATCH', {
        estado,
        resolucao: resolucaoTexto,
        valor_retido: parseFloat(valorRet || 0),
      });
      setSucesso('Disputa resolvida com sucesso.');
      setTimeout(() => setSucesso(''), 4000);
      setModal(null);
      setResolucao('');
      setValorRetido('');
      carregar();
    } catch (e) { setErro(e.message); setTimeout(() => setErro(''), 4000); }
    finally { setSalvando(false); }
  };

  const abertas  = disputas.filter(d => d.estado === 'aberta' || d.estado === 'em_analise');
  const fechadas = disputas.filter(d => d.estado === 'resolvida' || d.estado === 'encerrada');
  const urgentes = abertas.filter(d => parseFloat(d.horas_abertas) > 24);
  const lista    = filtro === 'abertas' ? abertas : fechadas;

  const horasLabel = (h) => {
    const n = Math.round(parseFloat(h));
    if (n < 1) return 'há menos de 1h';
    if (n < 24) return `há ${n}h`;
    return `há ${Math.floor(n/24)}d ${n%24}h`;
  };

  return (
    <>
      {/* Modal resolução */}
      {modal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
          <div style={{background:'var(--card)',borderRadius:'16px',padding:'24px',width:'100%',maxWidth:'420px',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
            <div style={{fontSize:'15px',fontWeight:'600',marginBottom:'4px'}}>
              {modal.tipo === 'devolver' ? 'Devolver caução ao cliente' : 'Reter caução (parcial ou total)'}
            </div>
            <div style={{fontSize:'12px',color:'var(--text-muted)',marginBottom:'18px'}}>
              Disputa: <strong>{modal.disputa.anuncio_titulo}</strong> · Caução total: <strong>{parseFloat(modal.disputa.valor_caucao||0).toLocaleString()} Kz</strong>
            </div>

            {modal.tipo === 'reter' && (
              <div style={{marginBottom:'14px'}}>
                <label style={{fontSize:'12px',fontWeight:'500',color:'var(--text-secondary)',display:'block',marginBottom:'5px'}}>
                  Valor a reter (Kz) *
                </label>
                <input type="number" min="0" max={modal.disputa.valor_caucao}
                  value={valorRetido} onChange={e => setValorRetido(e.target.value)}
                  placeholder={`Máx ${parseFloat(modal.disputa.valor_caucao||0).toLocaleString()} Kz`}
                  style={{width:'100%',padding:'10px 12px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'8px',fontSize:'13px',color:'var(--text-primary)',fontFamily:'inherit',outline:'none'}}/>
              </div>
            )}

            <div style={{marginBottom:'18px'}}>
              <label style={{fontSize:'12px',fontWeight:'500',color:'var(--text-secondary)',display:'block',marginBottom:'5px'}}>
                Fundamentação da decisão *
              </label>
              <textarea value={resolucao} onChange={e => setResolucao(e.target.value)}
                rows={3} placeholder="Descreve a decisão tomada e o motivo..."
                style={{width:'100%',padding:'10px 12px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'8px',fontSize:'13px',color:'var(--text-primary)',fontFamily:'inherit',outline:'none',resize:'vertical'}}/>
            </div>

            <div style={{display:'flex',gap:'8px',justifyContent:'flex-end'}}>
              <button className="btn btn-ghost btn-sm" onClick={() => { setModal(null); setResolucao(''); setValorRetido(''); }}>
                Cancelar
              </button>
              <button className="btn btn-primary btn-sm" disabled={!resolucao.trim() || salvando}
                style={{display:'flex',alignItems:'center',gap:'5px'}}
                onClick={() => resolver(modal.disputa.id, 'resolvida', resolucao, modal.tipo === 'reter' ? valorRetido : 0)}>
                <CheckIcon size={13}/> {salvando ? 'A guardar...' : 'Confirmar decisão'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal provas */}
      {provasId && (() => {
        const d = disputas.find(x => x.id === provasId);
        return d ? (
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}
            onClick={() => setProvasId(null)}>
            <div style={{background:'var(--card)',borderRadius:'16px',padding:'24px',width:'100%',maxWidth:'480px'}} onClick={e => e.stopPropagation()}>
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'16px'}}>
                <div style={{fontSize:'14px',fontWeight:'600'}}>Provas e descrição — {d.anuncio_titulo}</div>
                <button onClick={() => setProvasId(null)} style={{background:'transparent',border:'none',cursor:'pointer',color:'var(--text-muted)',fontSize:'20px',lineHeight:1}}>×</button>
              </div>
              <div style={{fontSize:'12px',color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:'6px'}}>Motivo</div>
              <div style={{fontSize:'13px',fontWeight:'600',marginBottom:'14px'}}>{d.motivo}</div>
              {d.descricao && (
                <>
                  <div style={{fontSize:'12px',color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:'6px'}}>Descrição</div>
                  <div style={{fontSize:'13px',color:'var(--text-secondary)',lineHeight:'1.6',background:'var(--surface)',borderRadius:'8px',padding:'12px',whiteSpace:'pre-line',marginBottom:'14px'}}>{d.descricao}</div>
                </>
              )}
              {d.provas?.length > 0 && (
                <>
                  <div style={{fontSize:'12px',color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:'8px'}}>Fotos/documentos</div>
                  <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                    {d.provas.map((url, i) => (
                      <a key={i} href={url} target="_blank" rel="noopener noreferrer">
                        <img src={url} alt={`prova ${i+1}`} style={{width:'80px',height:'80px',objectFit:'cover',borderRadius:'8px',border:'1px solid var(--border)'}}/>
                      </a>
                    ))}
                  </div>
                </>
              )}
              {(!d.provas || d.provas.length === 0) && (
                <div style={{fontSize:'12px',color:'var(--text-muted)',fontStyle:'italic'}}>Sem fotos ou documentos submetidos.</div>
              )}
            </div>
          </div>
        ) : null;
      })()}

      <div className="topbar">
        <div>
          <div className="topbar-title">Resolução de Disputas</div>
          <div className="topbar-sub">
            {abertas.length} aberta{abertas.length !== 1 ? 's' : ''} · {fechadas.length} resolvida{fechadas.length !== 1 ? 's' : ''}
            {abertas.length > 0 && ` · ${parseFloat(abertas.reduce((s,d) => s + parseFloat(d.valor_caucao||0), 0)).toLocaleString()} Kz em risco`}
          </div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={carregar} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <RefreshIcon size={14}/> Actualizar
          </button>
        </div>
      </div>

      <div className="page-content">
        {erro    && <div style={{background:'var(--danger-bg)',border:'1px solid var(--danger-border)',borderRadius:'10px',padding:'12px 16px',marginBottom:'14px',fontSize:'13px',color:'var(--danger)',display:'flex',gap:'8px',alignItems:'center'}}><AlertIcon size={14}/>{erro}</div>}
        {sucesso && <div style={{background:'var(--success-bg)',border:'1px solid var(--success-border)',borderRadius:'10px',padding:'12px 16px',marginBottom:'14px',fontSize:'13px',color:'var(--success)',display:'flex',gap:'8px',alignItems:'center'}}><CheckIcon size={14}/>{sucesso}</div>}

        {/* Alerta urgentes */}
        {urgentes.length > 0 && (
          <div style={{background:'var(--danger-bg)',border:'1px solid var(--danger-border)',borderRadius:'10px',padding:'12px 16px',marginBottom:'16px',display:'flex',gap:'10px',alignItems:'center'}}>
            <AlertIcon size={16} color='var(--danger)'/>
            <div style={{flex:1}}>
              <span style={{fontSize:'12px',fontWeight:'600',color:'var(--danger)'}}>
                {urgentes.length} disputa{urgentes.length !== 1 ? 's' : ''} excedeu{urgentes.length !== 1 ? 'ram' : ''} 24h sem resolução.
              </span>
              <span style={{fontSize:'12px',color:'var(--text-secondary)'}}> Decisão urgente necessária.</span>
            </div>
          </div>
        )}

        {/* Tabs */}
        <div style={{display:'flex',gap:'6px',marginBottom:'16px'}}>
          {[['abertas',`Abertas (${abertas.length})`],['resolvidas',`Resolvidas (${fechadas.length})`]].map(([id,label]) => (
            <button key={id} onClick={() => setFiltro(id)} style={{
              padding:'7px 14px',borderRadius:'8px',fontSize:'12px',fontWeight:'500',cursor:'pointer',fontFamily:'inherit',transition:'all 0.15s',
              background: filtro===id ? 'var(--orange)' : 'var(--card)',
              color:      filtro===id ? '#fff' : 'var(--text-secondary)',
              border:     `1px solid ${filtro===id ? 'var(--orange)' : 'var(--border)'}`,
            }}>{label}</button>
          ))}
        </div>

        {load ? (
          <div style={{textAlign:'center',padding:'60px',color:'var(--text-muted)'}}>
            <ClockIcon size={32} color='var(--border)'/>
            <div style={{marginTop:'10px'}}>A carregar disputas...</div>
          </div>
        ) : lista.length === 0 ? (
          <div className="card" style={{textAlign:'center',padding:'60px 20px'}}>
            <CheckIcon size={40} color='var(--success)'/>
            <div style={{fontSize:'15px',fontWeight:'600',marginTop:'12px',marginBottom:'6px',color:'var(--success)'}}>
              {filtro === 'abertas' ? 'Sem disputas abertas' : 'Sem disputas resolvidas'}
            </div>
            <div style={{fontSize:'13px',color:'var(--text-muted)'}}>
              {filtro === 'abertas' ? 'Nenhuma disputa pendente de resolução.' : 'As disputas resolvidas aparecem aqui.'}
            </div>
          </div>
        ) : lista.map(d => {
          const horas    = parseFloat(d.horas_abertas || 0);
          const urgente  = horas > 24 && (d.estado === 'aberta' || d.estado === 'em_analise');
          const ec       = ESTADOS_LABEL[d.estado] || ESTADOS_LABEL.aberta;
          const foto     = d.anuncio_fotos?.[0];

          return (
            <div key={d.id} className="card" style={{marginBottom:'12px',border: urgente ? '1.5px solid var(--danger-border)' : '1px solid var(--border)'}}>
              {urgente && (
                <div style={{display:'flex',alignItems:'center',gap:'6px',marginBottom:'10px'}}>
                  <AlertIcon size={11} color='var(--danger)'/>
                  <span style={{fontSize:'10px',fontWeight:'700',color:'var(--danger)',textTransform:'uppercase',letterSpacing:'0.5px'}}>Urgente — {horasLabel(horas)} sem resolução</span>
                  <span className={`badge ${ec.cls}`} style={{marginLeft:'auto'}}>{ec.label}</span>
                </div>
              )}

              <div style={{display:'flex',gap:'12px',alignItems:'flex-start'}}>
                {/* Foto anúncio */}
                <div style={{width:'52px',height:'52px',borderRadius:'9px',overflow:'hidden',flexShrink:0,background:'linear-gradient(135deg,#fde8d8,#fed7b0)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  {foto
                    ? <img src={foto} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                    : <PackageIcon size={22} color='#F97316'/>
                  }
                </div>

                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:'8px',marginBottom:'6px'}}>
                    <div>
                      <div style={{fontSize:'13px',fontWeight:'600'}}>{d.anuncio_titulo}</div>
                      <div style={{fontSize:'11px',color:'var(--text-muted)'}}>{horasLabel(horas)} · {d.motivo}</div>
                    </div>
                    {!urgente && <span className={`badge ${ec.cls}`}>{ec.label}</span>}
                  </div>

                  {/* Partes */}
                  <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'10px',flexWrap:'wrap'}}>
                    {[[d.cliente_nome,'#1A4A8A','Cliente'],[d.fornecedor_nome,'#F97316','Fornecedor']].map(([nome,cor,papel],i) => (
                      <React.Fragment key={papel}>
                        {i > 0 && <span style={{color:'var(--text-muted)',fontSize:'11px'}}>vs</span>}
                        <div style={{display:'flex',alignItems:'center',gap:'5px'}}>
                          <div style={{width:'22px',height:'22px',borderRadius:'50%',background:cor,display:'flex',alignItems:'center',justifyContent:'center',fontSize:'9px',fontWeight:'700',color:'#fff',flexShrink:0}}>
                            {(nome||'?')[0].toUpperCase()}
                          </div>
                          <span style={{fontSize:'11px',color:'var(--text-secondary)'}}>{nome} <span style={{color:'var(--text-muted)'}}>({papel})</span></span>
                        </div>
                      </React.Fragment>
                    ))}
                    <span style={{fontSize:'11px',color:'var(--text-muted)',marginLeft:'auto'}}>Aberta por: {d.iniciado_por_nome}</span>
                  </div>

                  {/* Métricas */}
                  <div className="grid-4" style={{gap:'8px',background:'var(--surface)',borderRadius:'8px',padding:'9px 11px',marginBottom:'10px'}}>
                    {[
                      ['Período',   `${new Date(d.data_inicio).toLocaleDateString('pt-PT')} – ${new Date(d.data_fim).toLocaleDateString('pt-PT')}`],
                      ['Aluguer',   `${parseFloat(d.valor_aluguer||0).toLocaleString()} Kz`],
                      ['Caução',    `${parseFloat(d.valor_caucao||0).toLocaleString()} Kz`],
                      ['Motivo',    d.motivo],
                    ].map(([l,v]) => (
                      <div key={l}>
                        <div style={{fontSize:'9px',color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.4px',fontWeight:'600',marginBottom:'2px'}}>{l}</div>
                        <div style={{fontSize:'11px',fontWeight:'600',color: l==='Caução'?'var(--danger)': l==='Motivo'?'var(--warning)':'var(--text-primary)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{v}</div>
                      </div>
                    ))}
                  </div>

                  {/* Resolução (se já resolvida) */}
                  {d.resolucao && (
                    <div style={{fontSize:'11px',color:'var(--text-secondary)',background:'var(--success-bg)',border:'1px solid var(--success-border)',borderRadius:'7px',padding:'8px 11px',marginBottom:'10px',lineHeight:'1.5'}}>
                      <strong style={{color:'var(--success)'}}>Resolução:</strong> {d.resolucao}
                      {d.valor_retido > 0 && <span style={{marginLeft:'8px',color:'var(--warning)'}}>· {parseFloat(d.valor_retido).toLocaleString()} Kz retidos</span>}
                    </div>
                  )}

                  {/* Acções */}
                  <div style={{display:'flex',gap:'6px',justifyContent:'flex-end',flexWrap:'wrap'}}>
                    <button className="btn btn-ghost btn-sm" onClick={() => setProvasId(d.id)}>Ver provas</button>
                    {(d.estado === 'aberta' || d.estado === 'em_analise') && (
                      <>
                        <button className="btn btn-sm"
                          style={{background:'transparent',color:'var(--success)',border:'1px solid var(--success)',borderRadius:'7px',padding:'5px 12px',fontSize:'11px',cursor:'pointer',fontFamily:'inherit',display:'flex',alignItems:'center',gap:'4px'}}
                          onClick={() => { setModal({ disputa: d, tipo: 'devolver' }); setValorRetido('0'); }}>
                          <CheckIcon size={11}/> Devolver caução
                        </button>
                        <button className="btn btn-primary btn-sm"
                          style={{display:'flex',alignItems:'center',gap:'4px'}}
                          onClick={() => { setModal({ disputa: d, tipo: 'reter' }); setValorRetido(d.valor_caucao||''); }}>
                          <XIcon size={11}/> Reter caução
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}
